import { render } from "./LoaderWrapper.vue?vue&type=template&id=72d3b690&ts=true"
import script from "./LoaderWrapper.vue?vue&type=script&lang=ts"
export * from "./LoaderWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__